import { TierNotFoundError } from "../../errors";
import validateConfig from "../validateConfig";
const getTierDetails = (config, tierId) => {
    validateConfig(config);
    config = config;
    const tierConfig = config.tiers.find(({ id }) => id === tierId);
    if (!tierConfig) {
        throw new TierNotFoundError(tierId);
    }
    return { ...tierConfig };
};
export default getTierDetails;
